import HTMLContent from '@/components/HTMLContent'

Vue.mixin({
  components: {
    HTMLContent
  }
})



// WEBPACK FOOTER //
// ./src/mixin/index.js